import { RefObject } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'

export const getInputProps = (inputProps: UseFormRegisterReturn) => {
  const { ref, min, max, ...rest } = inputProps

  return {
    inputRef: ref as unknown as RefObject<HTMLInputElement>,
    min: typeof min === 'number' ? min : undefined,
    max: typeof max === 'number' ? max : undefined,
    ...rest,
  }
}

export const getTextareaProps = (inputProps: UseFormRegisterReturn) => {
  const { ref, min, max, ...rest } = inputProps

  return {
    inputRef: ref as unknown as RefObject<HTMLTextAreaElement>,
    min: typeof min === 'number' ? min : undefined,
    max: typeof max === 'number' ? max : undefined,
    ...rest,
  }
}
